<template>
  <div class="suggest">
    <div class="line"></div>
    <div class="width1200">
      <div class="suggest-left">
        <ul>
          <li @click="getRoute = 'academic'">
            <router-link to="/suggest/academic" :class="{ active: getRoute == 'academic' }">乐团活动</router-link>
          </li>
          <li @click="getRoute = 'news'">
            <router-link to="/suggest/news" :class="{ active: getRoute == 'news' }">行业资讯</router-link>
          </li>
          <li @click="getRoute = 'infoMsg'">
            <router-link to="/suggest/infoMsg" :class="{ active: getRoute == 'infoMsg' }">信息公告</router-link>
          </li>
          <li @click="getRoute = 'theme'">
            <router-link to="/suggest/theme" :class="{ active: getRoute == 'theme' }">精彩专题</router-link>
          </li>
        </ul>
      </div>
      <div class="suggest-right">
        <router-view />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.suggest {
  overflow: hidden;
}
.line {
  height: 5px;
  background: #f9f9f9;
}
.suggest-left {
  width: 187px;
  height: 100%;
  float: left;
  background-color: #7aadaa;
  padding-bottom: 9999px;
  margin-bottom: -9999px;
  ul {
    padding-top: 20px;
    li {
      text-align: center;
      padding: 0 28px;
      a {
        display: block;
        border-bottom: 1px solid #9ec0be;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        line-height: 55px;
        &:hover,
        &.active {
          color: #225551;
        }
      }
    }
  }
}
.suggest-right {
  width: 1013px;
  float: right;
  box-sizing: border-box;
  min-height: 500px;
  // overflow: hidden;
}
</style>

<script>
/* eslint-disable */
export default {
  name: "suggest",
  data() {
    return {
      getRoute: "academic",
    };
  },
  mounted() {
    // let patt = new RegExp('events')
    // if(patt.test(route)) {
    //     this.getRoute = 'events'
    // }
  },
  beforeUpdate() {
    let route = this.$route.path;

    switch (route) {
      case "/suggest": {
        this.getRoute = "academic";
        this.$router.push({ path: "/suggest/academic" });
        break;
      }
      case "/suggest/academic": {
        this.$set(this, "getRoute", "academic");
        this.getRoute = "academic";
        break;
      }
      case "/suggest/news": {
        this.getRoute = "news";
        break;
      }
      case "/suggest/infoMsg": {
        this.getRoute = "infoMsg";
        break;
      }
      case "/suggest/theme": {
        this.getRoute = "theme";
        break;
      }
    }
  },
  methods: {},
};
</script>
